var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88571 15.3714C5.87321 15.7893 6.91964 16 8 16C9.08036 16 10.1268 15.7893 11.1143 15.3714C12.0679 14.9679 12.9232 14.3911 13.6571 13.6571C14.3911 12.9232 14.9679 12.0679 15.3714 11.1143C15.7893 10.1268 16 9.08036 16 8C16 6.91964 15.7893 5.87321 15.3714 4.88571C14.9679 3.93214 14.3911 3.07679 13.6571 2.34286C12.9232 1.60893 12.0679 1.03214 11.1143 0.628571C10.1268 0.210714 9.08036 0 8 0C6.91964 0 5.87321 0.210714 4.88571 0.628571C3.93214 1.03214 3.07679 1.60893 2.34286 2.34286C1.60893 3.07679 1.03214 3.93214 0.628571 4.88571C0.210714 5.87321 0 6.91964 0 8C0 9.08036 0.210714 10.1268 0.628571 11.1143C1.03214 12.0679 1.60893 12.9232 2.34286 13.6571C3.07679 14.3911 3.93214 14.9679 4.88571 15.3714Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32178 11.429H7.31821C7.16107 11.4272 7.01107 11.3629 6.90392 11.2487L3.86821 8.00223C3.65214 7.77188 3.66464 7.40938 3.89499 7.19509C4.12535 6.97902 4.48785 6.99152 4.70214 7.22188L7.32714 10.0272L11.3021 5.88973C11.52 5.66295 11.8825 5.65581 12.1093 5.87366C12.3361 6.09152 12.3432 6.45402 12.1253 6.68081L7.73249 11.2522C7.62714 11.3665 7.47714 11.429 7.32178 11.429V11.429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/circle-checked.2430dfa8f8d7260f9eba57243ca6626b.svg";
export { ForwardRef as ReactComponent };